import {
  DRL_COMPOUNDING_PERIODS_ALIAS,
  DRL_COMPOUNDING_ROW_NUMBER,
  DRL_EFFECTIVE_DATE_ALIAS,
  DRL_EFFECTIVE_DATE_ROW_NUMBER,
} from 'common/constants/cap-table';
import {
  COMPOUNDING_PERIOD_IS_REQUIRED_FEEDBACK,
  COMPOUNDING_PERIOD_MIN_VALUE_FEEDBACK,
  PREVIOUS_EFFECTIVE_DATE_FEEDBACK,
} from 'pages/CapTable/cap-table/data/validationsConstants';
import { validateEffectiveDateWithInvestmentDate } from 'pages/CapTable/cap-table/utilities';
import { getColumnIndex, getColumnLetter } from 'utilities';
import { DivRateCell, DivRateLedgerValidationsParams } from './types';

const FIRST_COLUMN_LETTER = 'A';

const validateCompoundingPeriod = ({
  cell,
  addFeedbackFromCell,
  removeFeedbackFromCell,
  parsedColumns,
}: DivRateLedgerValidationsParams) => {
  const { value, columnLegend } = cell;
  const hasCompoundingKey = `${columnLegend as string}${DRL_COMPOUNDING_ROW_NUMBER}`;
  const hasCompoundingEnabled = parsedColumns[hasCompoundingKey]?.value;
  if (hasCompoundingEnabled) {
    if (!value) {
      addFeedbackFromCell?.(cell, COMPOUNDING_PERIOD_IS_REQUIRED_FEEDBACK);
    } else {
      removeFeedbackFromCell?.(cell, COMPOUNDING_PERIOD_IS_REQUIRED_FEEDBACK);
    }
    if (Number(value) < 1) {
      addFeedbackFromCell?.(cell, COMPOUNDING_PERIOD_MIN_VALUE_FEEDBACK);
    } else {
      removeFeedbackFromCell?.(cell, COMPOUNDING_PERIOD_MIN_VALUE_FEEDBACK);
    }
  }
};

const validateEffectiveDate = ({
  cell,
  addFeedbackFromCell,
  removeFeedbackFromCell,
  parsedColumns,
  tableData,
}: DivRateLedgerValidationsParams) => {
  const { cellColumnRef, securities } = tableData;
  const baseSecurity = securities.find(security => security.columnRef === cellColumnRef);
  const investmentDate = baseSecurity?.investment_date;
  const { value, columnLegend } = cell;
  if (columnLegend !== FIRST_COLUMN_LETTER) {
    // validate that the previous cell effective date is lower than the current cell effective date
    const currentColumnNumber = getColumnIndex(columnLegend);
    const referencedColumnLegend = getColumnLetter((currentColumnNumber as number) - 1);
    const referencedCell = parsedColumns[`${referencedColumnLegend}${DRL_EFFECTIVE_DATE_ROW_NUMBER}`];
    if (referencedCell?.value) {
      const isValid = new Date(value as string) > new Date(referencedCell.value as string);
      if (!isValid) {
        addFeedbackFromCell?.(cell, PREVIOUS_EFFECTIVE_DATE_FEEDBACK);
      } else {
        removeFeedbackFromCell?.(cell, PREVIOUS_EFFECTIVE_DATE_FEEDBACK);
      }
    }
  }
  validateEffectiveDateWithInvestmentDate<DivRateCell>({
    cell,
    investmentDate,
    addFeedbackFromCell,
    removeFeedbackFromCell,
  });
};

const validations = (params: DivRateLedgerValidationsParams) => {
  const { cell, parsedColumns, addFeedbackFromCell, removeFeedbackFromCell, tableData } = params;
  const { alias } = cell;
  if (alias === DRL_COMPOUNDING_PERIODS_ALIAS) {
    validateCompoundingPeriod({ cell, addFeedbackFromCell, removeFeedbackFromCell, parsedColumns, tableData });
  }
  if (alias === DRL_EFFECTIVE_DATE_ALIAS) {
    validateEffectiveDate({ cell, addFeedbackFromCell, removeFeedbackFromCell, parsedColumns, tableData });
  }
};

export default validations;
